var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class": "sightline-transaction-dialog",
        width: "500",
        persistent: _vm.isDialogPersistent
      },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _vm.isTitleVisible && !_vm.isProcessing && !_vm.hideResult
            ? _c(
                "v-card-title",
                {
                  staticClass: "headline grey lighten-3",
                  attrs: { "primary-title": "" }
                },
                [
                  _vm._t("title", function() {
                    return [
                      _c("div", [
                        _vm.isSuccess
                          ? _c("span", [_vm._v(_vm._s(_vm.successTitle))])
                          : _c("span", { staticClass: "red--text" }, [
                              _vm._v(_vm._s(_vm.errorTitle))
                            ])
                      ])
                    ]
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "dialog-content" },
            [
              _vm.isProcessing
                ? _vm._t("text-processing", function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "dialog-processing" },
                        [
                          _c("v-progress-circular", {
                            staticClass: "circular-progress",
                            attrs: { indeterminate: "" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.processingText))])
                        ],
                        1
                      )
                    ]
                  })
                : !_vm.hideResult
                ? _c(
                    "div",
                    [
                      _vm.isSuccess
                        ? _vm._t("text-success", function() {
                            return [
                              _c(
                                "p",
                                { staticClass: "generic-icon-note" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-1",
                                      attrs: { color: "success" }
                                    },
                                    [_vm._v("check_circle")]
                                  ),
                                  _c("span", [_vm._v(_vm._s(_vm.successText))])
                                ],
                                1
                              )
                            ]
                          })
                        : _vm._t("text-error", function() {
                            return [
                              _c(
                                "p",
                                { staticClass: "generic-icon-note" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-1",
                                      attrs: { color: "error" }
                                    },
                                    [_vm._v("error")]
                                  ),
                                  _c("span", [_vm._v(_vm._s(_vm.errorText))])
                                ],
                                1
                              )
                            ]
                          })
                    ],
                    2
                  )
                : _c("div")
            ],
            2
          ),
          _vm._v(" "),
          _vm.showActions
            ? _c("v-divider", { staticClass: "actions-divider" })
            : _vm._e(),
          _vm._v(" "),
          _vm.showActions
            ? _c(
                "v-card-actions",
                [
                  _vm._t("actions", function() {
                    return [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", disabled: _vm.isProcessing },
                          on: { click: _vm.dialogClose }
                        },
                        [_vm._v(_vm._s(_vm.closeBtnText))]
                      )
                    ]
                  })
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3af326c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3af326c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/PaysafeProcessingDialog.vue
// module id = null
// module chunks = 